import { useContext, useMemo, useState } from "react";
import GroupeCategorieServices from "../services/groupeCategorieServices";
import { AuthContext } from "../contexts/AuthContext";

function useGroupeCategorie() {
  const { api } = useContext(AuthContext);

  const service = useMemo(() => new GroupeCategorieServices(api), [api]);

  const [groupes, setGroupes] = useState([]);
  const [loading, setLoading] = useState(false);

  const normalizeList = (res) => {
    const data = res?.data?.data ?? res?.data ?? [];
    return Array.isArray(data) ? data : [];
  };

  const fetchGroupes = async () => {
    setLoading(true);
    try {
      const res = await service.getAll();
      setGroupes(normalizeList(res));
      return res;
    } finally {
      setLoading(false);
    }
  };

  const getAllGroupCategories = async() =>{
    const res = await service.getAll();
    return res;
  }

  const createGroupe = async (data) => {
    const res = await service.create(data);
    await fetchGroupes();
    return res;
  };

  const updateGroupe = async (id, data) => {
    const res = await service.update(id, data);
    await fetchGroupes();
    return res;
  };

  const deleteGroupe = async (id) => {
    const res = await service.delete(id);
    await fetchGroupes();
    return res;
  };

  return {
    groupes,
    loading,
    fetchGroupes,
    createGroupe,
    updateGroupe,
    deleteGroupe,
    getAllGroupCategories
  };
}

export default useGroupeCategorie;
